import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api';

console.log(`[API] Current API_URL: ${API_URL}`);

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30 second timeout
  headers: {
    // Content-Type is handled dynamically by axios based on the data sent
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Only redirect on actual 401 Unauthorized responses (not network errors)
    if (error.response?.status === 401) {
      // Clear auth data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Only redirect if we're not already on the login page to avoid 404s on refresh
      const isLoginPage = window.location.pathname === '/login' || window.location.hash.startsWith('#/login');
      if (!isLoginPage) {
        // Use HashRouter compatible path for better reliability across hostings
        window.location.href = '/#/login';
      }
      return Promise.reject(error);
    }
    // Return the error response data if it's an object, otherwise return a descriptive error
    let errorData;
    if (error.response?.data && typeof error.response.data === 'object') {
      errorData = error.response.data;
    } else {
      errorData = { 
        error: error.response?.status === 404 
          ? 'API endpoint not found (check VITE_API_URL on Render)' 
          : (error.message || 'Network error occurred') 
      };
    }
    return Promise.reject(errorData);
  }
);

export default api;